import { Patient } from '../model/patient/patient.model'

/**
 * Build a draft Patient from an eligibility's standardized subscriber payload,
 * suitable for seeding a patient-create form.
 *
 * Returns undefined when there's nothing useful to copy.
 */
export function buildPatientDraftFromSubscriber(
  subscriber: Record<string, any> | undefined,
  defaults?: { clinicId?: string },
): Patient | undefined {
  if (!subscriber) {
    return undefined
  }

  const name = subscriber.name
  const address = subscriber.address
  const hasName = name && (name.given || name.family || name.middle)
  const hasAddress = address && (address.address1 || address.city || address.state || address.zip)
  const hasAnySeed = hasName || subscriber.dob || subscriber.gender || subscriber.ssn || hasAddress

  if (!hasAnySeed) {
    return undefined
  }

  return new Patient({
    clinicId: defaults?.clinicId,
    name: hasName ? { ...name } : {},
    address: hasAddress ? { ...address } : {},
    dob: subscriber.dob,
    sex: subscriber.gender,
    ssn: subscriber.ssn,
  })
}
